import React from 'react';
import { useDialog } from '../contexts/DialogContext';

export const CTA: React.FC = () => {
  const { openDialog } = useDialog();

  return (
    <div className="relative -z-10 mt-24 px-6 lg:px-8">
      <div
        aria-hidden="true"
        className="absolute inset-x-0 top-1/2 -z-10 flex -translate-y-1/2 transform-gpu justify-center overflow-hidden blur-3xl sm:top-auto sm:right-[calc(50%-6rem)] sm:bottom-0 sm:translate-y-0 sm:transform-gpu sm:justify-end"
      >
        <div
          style={{
            clipPath:
              'polygon(73.6% 48.6%, 91.7% 88.5%, 100% 53.9%, 97.4% 18.1%, 92.5% 15.4%, 75.7% 36.3%, 55.3% 52.8%, 46.5% 50.9%, 45% 37.4%, 50.3% 13.1%, 21.3% 36.2%, 0.1% 0.1%, 5.4% 49.1%, 21.4% 36.4%, 58.9% 100%, 73.6% 48.6%)',
          }}
          className="aspect-[1108/632] w-[69.25rem] flex-none bg-gradient-to-r from-[#CFF710] to-[#00D084] opacity-25"
        />
      </div>
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-4xl font-semibold tracking-tight text-balance sm:text-5xl" style={{ color: '#241E61' }}>
          Your products deserve better after the sale
        </h2>
        <p className="mx-auto mt-6 max-w-xl text-lg/8 text-gray-600">
          Start free on one product line. See the difference in registration rates, support costs, and customer relationships — in days, not months.
        </p>
        <div className="mt-10 flex items-center justify-center gap-x-6">
          <button
            onClick={() => openDialog('waitlist')}
            className="rounded-md px-4 py-3 text-base font-bold shadow-lg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600 transition-all duration-200 transform hover:scale-105"
            style={{
              background: 'linear-gradient(135deg, #CFF710 0%, #00D084 100%)',
              boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
              color: '#1a1a1a'
            }}
          >
            Start your free pilot
          </button>
          <a href="/blog/" className="text-sm/6 font-semibold transition-colors" style={{ color: '#241E61' }}>
            Read the blog <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
      </div>
    </div>
  );
};
